import moment from "moment-timezone"

export function viennaTime(date, dateformat = "%d.%m.%Y %H:%M:%S") {
  let momentDate = moment()
  if (date !== "now") {
    momentDate = moment(date)
  }
  return momentDate.tz('Europe/Vienna').format(dateformat)
}
